import RecordingCrashFallback from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/Creations/RecordInterviewPage/RecordingErrorBoundary/RecordingCrashFallback';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import * as React from 'react';

type Props = {
	subject: SubjectAddress;
	localInterviewId: string;
	children: React.ReactNode;
};

type State = { hasFailed: boolean };

/** React only offers error boundaries as classes: the one place this codebase departs from `React.FC`. */
class RecordingErrorBoundary extends React.Component<Props, State> {
	override state: State = { hasFailed: false };

	static getDerivedStateFromError(): State {
		return { hasFailed: true };
	}

	override render(): React.ReactNode {
		if (this.state.hasFailed) {
			return (
				<RecordingCrashFallback
					subject={this.props.subject}
					localInterviewId={this.props.localInterviewId}
				/>
			);
		}

		return this.props.children;
	}
}

export default RecordingErrorBoundary;
